import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getDeliveryDestAPI,
  getDeliveryDestDetailAPI,
  addDeliveryDestAPI,
  updateDeliveryDestAPI,
  deleteDeliveryDestAPI,
} from './api';
import {
  filterDeliveryDest,
  filterDeliveryDestSuccess,
  filterDeliveryDestFailure,
  getDetailDeliveryDest,
  getDetailDeliveryDestSuccess,
  getDetailDeliveryDestFailure,
  registerDeliveryDest,
  registerDeliveryDestSuccess,
  registerDeliveryDestFailure,
  updateDeliveryDest,
  updateDeliveryDestSuccess,
  updateDeliveryDestFailure,
  deleteDeliveryDest,
  deleteDeliveryDestSuccess,
  deleteDeliveryDestFailure,
} from './slice';

function* fetchDeliveryDestMaster({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getDeliveryDestAPI, trimQueryData(payload));
    yield put(filterDeliveryDestSuccess(response.data));
  } catch (error) {
    yield put(filterDeliveryDestFailure());
  }
}

function* fetchDeliveryDestDetail({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getDeliveryDestDetailAPI, payload);
    yield put(getDetailDeliveryDestSuccess(response));
  } catch (error: any) {
    yield put(getDetailDeliveryDestFailure({ message: error?.message }));
  }
}

function* registerDeliveryDestSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(addDeliveryDestAPI, payload);
    yield put(registerDeliveryDestSuccess(response));
  } catch (error: any) {
    yield put(registerDeliveryDestFailure({ message: error?.message }));
  }
}

function* updateDeliveryDestSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(updateDeliveryDestAPI, payload);
    yield put(updateDeliveryDestSuccess(response));
  } catch (error: any) {
    yield put(updateDeliveryDestFailure({ message: error?.message }));
  }
}

function* deleteDeliveryDestSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(deleteDeliveryDestAPI, payload);
    yield put(deleteDeliveryDestSuccess(response));
  } catch (error: any) {
    yield put(deleteDeliveryDestFailure({ message: error?.message }));
  }
}

function* watchDeliveryDestMaster() {
  yield takeLatest(filterDeliveryDest, fetchDeliveryDestMaster);
  yield takeLatest(getDetailDeliveryDest, fetchDeliveryDestDetail);
  yield takeLatest(registerDeliveryDest, registerDeliveryDestSaga);
  yield takeLatest(updateDeliveryDest, updateDeliveryDestSaga);
  yield takeLatest(deleteDeliveryDest, deleteDeliveryDestSaga);
}

export default watchDeliveryDestMaster;
